<template>
  <div id="audios">
      <v-container>
        
        <span v-if="language==='RU'"><PageTitle :title="title_RU" class="mt-4" /></span>
        <span v-if="language==='EN'"><PageTitle :title="title_EN" class="mt-4" /></span>

          <v-layout row wrap align-center justify-center fill-height class="mt-4">
              <v-flex xs12 sm6>
                <AudioBlock :file="file1" />
              </v-flex>
              <v-flex xs12 sm6>
                <AudioBlock :file="file2" />
              </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-center fill-height class="mt-4">          
              <v-flex xs12 sm6>
                <AudioBlock :file="file3" />
              </v-flex> 
              <v-flex xs12 sm6>
                <AudioBlock :file="file4" />
              </v-flex> 
          </v-layout>
          <v-layout row wrap align-center justify-center fill-height class="mt-4">            
              <v-flex xs12 sm6>
                <AudioBlock :file="file5" />
              </v-flex> 
              <v-flex xs12 sm6>
                <AudioBlock :file="file6" />
              </v-flex>                                                     
          </v-layout>        
      </v-container>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import AudioBlock from '@/components/AudioBlock'

    export default {
      name: 'Audio',
      components: { PageTitle, AudioBlock },
    data() {
      return {
        language: '',

        title_RU: 'Аудио',
        title_EN: 'Audio',

        file1: {
          name: 'Adagio',
          author: 'T. Albinoni',
          url: 'adagio.mp3'
        },
        file2: {
          name: 'Bolero Espanol',
          author: 'F. Kiara',
          url: 'bolero_espanol.mp3'
        },
        file3: {
          name: 'Italian song',
          author: 'E. Shapplin',
          url: 'italian_song.mp3'
        },
        file4: {
          name: 'Lauretta\'s aria "O mio babino caro"',
          author: 'G. Puccini',
          url: 'lauretta.mp3'
        },
        file5: {
          name: 'Musetta',
          author: 'G. Puccini',
          url: 'musetta.mp3'
        },
        file6: {
          name: 'La Wally\'saria from opera "La Wally"',
          author: 'A. Catalani',
          url: 'walli.mp3'
        }                                                   
      }
    },
    mounted(){
      if(localStorage.lang){
        this.language = localStorage.lang
      }
    }
  }
</script>


